// Simple PWA functionality for REHomebase
// Handles online/offline status and basic sync

(function() {
  'use strict';

  // Online/Offline status handling
  function updateOnlineStatus() {
    const isOnline = navigator.onLine;
    const statusElement = document.querySelector('.connection-status');

    if (statusElement) {
      statusElement.classList.toggle('online', isOnline);
      statusElement.classList.toggle('offline', !isOnline);
      statusElement.textContent = isOnline ? 'Online' : 'Offline';
    }

    // Show/hide offline banner
    const offlineBanner = document.querySelector('.offline-banner');
    if (offlineBanner) {
      offlineBanner.style.display = isOnline ? 'none' : 'block';
    }
  }

  // Simple background sync when coming back online
  function handleOnlineEvent() {
    console.log('[PWA] Back online');
    updateOnlineStatus();

    // Simple refresh if we have pending changes (Turbo will handle this gracefully)
    if (document.body.classList.contains('has-pending-changes')) {
      setTimeout(() => {
        if (confirm('You\'re back online! Would you like to refresh to sync any changes?')) {
          window.location.reload();
        }
      }, 1000);
    }
  }

  function handleOfflineEvent() {
    console.log('[PWA] Gone offline');
    updateOnlineStatus();
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function() {
    updateOnlineStatus();

    // Listen for online/offline events
    window.addEventListener('online', handleOnlineEvent);
    window.addEventListener('offline', handleOfflineEvent);

    // Track if there are any pending form changes
    const forms = document.querySelectorAll('form');
    forms.forEach(form => {
      form.addEventListener('input', function() {
        if (!navigator.onLine) {
          document.body.classList.add('has-pending-changes');
        }
      });
    });
  });

  // Service Worker registration
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', function() {
      navigator.serviceWorker.register('/service-worker.js')
        .then(function(registration) {
          console.log('[PWA] Service Worker registered successfully:', registration.scope);
        })
        .catch(function(error) {
          console.log('[PWA] Service Worker registration failed:', error);
        });
    });
  }

  // Install prompt handling
  let deferredPrompt;

  window.addEventListener('beforeinstallprompt', function(e) {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    deferredPrompt = e;

    // Show install button
    const installButton = document.querySelector('.install-app-button');
    if (installButton) {
      installButton.style.display = 'block';
      installButton.addEventListener('click', function() {
        installButton.style.display = 'none';
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then(function(choiceResult) {
          if (choiceResult.outcome === 'accepted') {
            console.log('[PWA] User accepted the install prompt');
          } else {
            console.log('[PWA] User dismissed the install prompt');
          }
          deferredPrompt = null;
        });
      });
    }
  });

})();
